<template>
	<aside class="iv2-bottom-nav theme-b__bottom-bg position-fixed text-center d-md-none d-lg-none">
		<nav class="iv2-bottom-nav__sub-menu">
			<ul class="iv2-bottom-nav__sub-list list-unstyled">
				<li v-for="nav in bottom_menu" :key="nav.id" class="iv2-bottom-nav__sub-item">
					<router-link
						v-if="nav.link_type == 'internal'"
						:to="nav.url"
						@click.native="activeMenu = false"
						class="iv2-bottom-nav__sub-link theme-b__bottom-link"
					>
						<i
							:class="
                                'iv2-bottom-nav__sub-item-icon d-block ' +
                                    nav.icon
                            "
						></i>
						<span class="iv2-bottom-nav__sub-item-text d-block">
							{{
							nav.name
							}}
						</span>
					</router-link>
					<a
						v-else-if="nav.link_type == 'external'"
						v-bind:href="nav.url"
						:target="nav.target_type"
						rel="noopener"
						class="iv2-bottom-nav__sub-link theme-b__bottom-link"
					>
						<i
							:class="
                                'iv2-bottom-nav__sub-item-icon d-block ' +
                                    nav.icon
                            "
						></i>
						<span class="iv2-bottom-nav__sub-item-text d-block">
							{{
							nav.name
							}}
						</span>
					</a>
					<div v-else-if="nav.link_type == 'push'" class="iv2-bottom-push-button">
						<button
							class="iv2-bottom-nav__sub-link theme-b__bottom-link"
							style="background-color: transparent; border: none;"
						>
							<i
								:class="
                                    'iv2-bottom-nav__sub-item-icon d-block ' +
                                        nav.icon
                                "
							></i>
							<span class="iv2-bottom-nav__sub-item-text d-block">{{ nav.name }}</span>
						</button>
					</div>
				</li>
			</ul>
		</nav>
	</aside>
</template>

<script>
export default {
	data() {
		return {
			bottom_menu: [],
		};
	},

	created() {
		this.axios.get("/json/navigations.json").then((response) => {
			this.bottom_menu = response.data.navs.bottom_menu;
		});
	},
};
</script>

<style lang="scss">
/* SP Only */
@media (max-width: 767px) {
	.iv2-bottom-nav {
		padding: 0;
		display: block;
		border-left: none;
		-webkit-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
		mix-blend-mode: normal;

		.iv2-bottom-nav__sub-menu {
			height: 100%;
			.iv2-bottom-nav__sub-list {
				margin-bottom: 0;
				height: 100%;
				display: -webkit-box;
				display: -ms-flexbox;
				display: flex;
				align-items: center;
				-ms-flex-pack: distribute;
				justify-content: space-around;

				.iv2-bottom-nav__sub-item {
					margin-bottom: 0;
					width: 100%;
					position: relative;

					&::after {
						content: "";
						height: 45px;
						border-right: 1px dotted;
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
					}

					&:last-child {
						&::after {
							content: none;
						}
					}

					.iv2-bottom-nav__sub-link {
						-webkit-transition: 0.3s;
						transition: 0.3s;
						vertical-align: middle;
						padding: 0;

						&:hover {
							text-decoration: none;
							opacity: 0.5;
						}
					}

					.iv2-bottom-nav__sub-item-icon {
						margin-bottom: 5px;
						font-size: 1.2rem;
					}

					.iv2-bottom-nav__sub-item-text {
						font-size: 10px;
						font-weight: 400;
						line-height: 1.2;
						max-width: 65px;
						margin: 0 auto;
					}
				}
			}
		}
	}
}
</style>
